<template>
  <v-container class="fill-height pa-0" fluid>
    <v-card class="d-flex justify-center align-center login-page-container">
      <v-row>
        <v-col cols="12" md="6" class="pa-0">
          <v-card tile flat class="right-side-card">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="heading-h3">Join Easi Rewards with</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                  <FacebookAuthBtn class="full-width" />
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                  <GoogleAuthBtn class="full-width" />
                </v-col>
              </v-row>
              <v-divider class="my-2" />
              <v-row>
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                  <v-form v-on:submit.prevent="signup" v-model="isSignUpFormValid">
                    <v-text-field label="Email" name="email" outlined dense type="text" required :rules="emailRules" v-model="email" />
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field label="First name" name="first-name" outlined dense type="text" required :rules="fistNameRules" v-model="firstName" />
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field label="Last name" name="last-name" outlined dense type="text" required :rules="lastNameRules" v-model="lastName" />
                      </v-col>
                    </v-row>
                    <v-text-field label="Create a password" name="password" outlined dense :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" required :rules="passwordRules" v-model="password" @click:append="showPassword = !showPassword" />
                    <v-text-field label="Confirm password" name="confirm_password" outlined dense :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'" :type="showPasswordConfirmation ? 'text' : 'password'" required :rules="confirmPasswordRules" v-model="passwordConfirmation" @click:append="showPasswordConfirmation = !showPasswordConfirmation" />
                    <!-- TODO: add link for terms and condition and privacy policy -->
                    <v-checkbox v-model="isTermAndConditionAgreed" required :rules="termsRules">
                      <div slot="label">
                        I agree with the
                        <router-link :to="{ name: 'TermsOfServicePage' }">
                          Terms of Service
                        </router-link>
                        and
                        <router-link :to="{ name: 'PrivacyPolicyPage' }">
                          Privacy Policy
                        </router-link>
                      </div>
                    </v-checkbox>
                    <v-row>
                      <v-col cols="12" md="6" class="d-flex justify-md-start justify-center">
                        <v-btn text color="primary" @click="goBack">Back</v-btn>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex justify-md-end justify-center">
                        <v-btn color="secondary" type="submit" :disabled="!isSignUpFormValid">Sign up</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
            <p class="text-center mb-8">
              <router-link :to="{ name: 'Login' }">Already have an account?</router-link>
            </p>
            <p class="text-center">
              This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="d-flex pa-0">
          <v-card tile flat class="left-side-card">
            <div class="heading-h1 white--text pa-4">Winning the chore wars starts now!</div>
            <div class="body-heading-medium white--text pa-4 font-weight-regular">After you setup your parent account here you’ll be able to setup accounts for your kids and start those Quests! Where do they need a nudge? That’s up to you. We’ll make sure they know what needs doing and when.</div>
            <div class="body-heading-medium white--text pa-4 font-weight-regular">Don't forget, there's 500 FREE seed points to to get you started on the first couple of quests!</div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  import FacebookAuthBtn from "@/components/FacebookAuthBtn";
  import GoogleAuthBtn from "@/components/GoogleAuthBtn";

  export default {
    name: "Signup",
    data() {
      return {
        showPassword: false,
        showPasswordConfirmation: false,
        email: "",
        password: "",
        passwordConfirmation: "",
        phone: "",
        firstName: "",
        lastName: "",
        fistNameRules: [(v) => !!v || "First name is required"],
        lastNameRules: [(v) => !!v || "Last name is required"],
        phoneRules: [(v) => !!v || "Phone number is required", (v) => (v && v.length >= 10) || "Phone number must be at least 10 numbers"],
        emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
        passwordRules: [(v) => !!v || "Password is required"],
        confirmPasswordRules: [(v) => !!v || "Password is required", (v) => v === this.password || "Password do not match"],
        termsRules: [(v) => !!v || "You must agree to continue"],
        isTermAndConditionAgreed: false,
        isSignUpFormValid: false,
        recaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY,
      };
    },

    created() {
      this.checkLogin();
    },

    updated() {
      this.checkLogin();
    },
    components: {
      FacebookAuthBtn,
      GoogleAuthBtn,
    },
    computed: {
      isLoggedIn: function() {
        return this.$store.getters.isLoggedIn;
      },
      user() {
        return this.$store.getters.userInfo;
      },
    },
    methods: {
      redirectToDashboard(role) {
        if (role) {
          if (role.indexOf("parent") > -1) {
            this.$router.replace("/parentdashboard");
          }

          if (role.indexOf("child") > -1) {
            this.$router.replace("/childdashboard");
          }
        } else {
          this.$router.replace("/oops");
        }
      },

      signup() {
        this.$store.commit("setLoadingStatus", true);
        grecaptcha.ready(() => {
          grecaptcha
            .execute(this.recaptchaSiteKey, { action: "submit" })
            .then(
              (token) => {
                this.$http
                  .post("/recaptcha/verify", { token: token })
                  .then((response) => {
                    this.$http
                      .post("/parents", {
                        parent: {
                          email: this.email,
                          password: this.password,
                          password_confirmation: this.passwordConfirmation,
                          phone: this.phone,
                          name: this.firstName + " " + this.lastName,
                          is_term_and_condition_agreed: this.isTermAndConditionAgreed,
                        },
                      })
                      .then((response) => this.signupSuccess(response))
                      .catch((error) => this.signupFail(error));
                  })
                  .catch((error) => this.signupFail(error));
              },
              (error) => {
                console.error(error);
                this.signupFail(error);
              }
            )
            .catch((error) => {
              console.error(error);
              this.signupFail(error);
            });
        });
      },

      signupSuccess(response) {
        this.$store.commit("setError", {
          message: "ALL DONE! PLEASE CHECK YOUR EMAIL. You will shortly receive an email with instructions for activating your account. Please check spam folder if you do not receive email in the next few minutes and add our account to safe senders list.",
          type: "success",
        });
        delete localStorage.token;
        delete localStorage.role;

        this.$store.commit("setLoadingStatus", false);

        this.$router.push({ name: "Home" });
      },

      signupFail(error) {
        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });
        delete localStorage.token;
        delete localStorage.role;
        this.$store.commit("setLoadingStatus", false);
      },

      checkLogin() {
        if (this.isLoggedIn) {
          this.redirectToDashboard(this.user.role);
        }
      },

      goBack() {
        this.$router.go(-1);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";

  .login-page-container {
    background: url(../assets/parent_login_bcg_img.png);
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0px !important;
    padding: 7% 16%;
    width: 100%;

    .left-side-card {
      background-color: $primary-blue !important;
      padding: 12% 8%;
    }

    .right-side-card {
      padding: 12% 8%;
    }

    .full-width {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue